module.exports = __webpack_public_path__ + "static/onekey-6701ad6c9263bec350e647e1b20c9a6d.webp";